import { defineStore } from "pinia"
import { computed, ref } from "vue"

export const useFormsStore = defineStore('FormsStore', () => {

    const forms = ref<any>(null)

    return { forms }
})
